<template>
  <div class="list-box-wrapper">
    <div class="list-box-item">
      <div class="search-box">
        <input v-model="searchSource" type="text" placeholder="Search" />
        <div
          v-if="searchSource"
          class="clear-search"
          title="Clear Search"
          @click="searchSource = ''"
        >
          &times;
        </div>
      </div>
      <ul class="list-box">
        <li
          v-for="(item, key) in internalSource
            .map((item, inx) => ({ inx, ...item }))
            .filter((item) =>
              (displayFunc1
                ? displayFunc1(item)
                : item[label in item ? label : 'label']
              )
                .toLowerCase()
                .includes(searchSource.toLowerCase())
            )"
          v-bind:key="key"
          :class="'list-item' + (item.selected ? ' active' : '')"
          @click="selectSource(searchSource ? item.inx : key)"
        >
          {{
            displayFunc1
              ? displayFunc1(item)
              : item[label in item ? label : "label"]
          }}
        </li>
        <li
          v-if="
            internalSource.filter((item) =>
              (displayFunc1
                ? displayFunc1(item)
                : item[label in item ? label : 'label']
              )
                .toLowerCase()
                .includes(searchSource.toLowerCase())
            ).length == 0 && internalSource.length
          "
          class="list-item"
        >
          No results found
        </li>
      </ul>
    </div>
    <div class="actions">
      <div class="btn-action" @click="moveDestination">
        <svg height="18" viewBox="0 0 256 512">
          <path
            fill="#ffffff"
            d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
          />
        </svg>
      </div>
      <div class="btn-action" @click="moveSource" v-if="noRemove !== true">
        <svg height="18" viewBox="0 0 256 512">
          <path
            fill="#ffffff"
            d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
          />
        </svg>
      </div>
    </div>
    <div class="list-box-item">
      <div class="search-box">
        <input v-model="searchDestination" type="text" placeholder="Search" />
        <div
          v-if="searchDestination"
          class="clear-search"
          title="Clear Search"
          @click="searchDestination = ''"
        >
          &times;
        </div>
      </div>
      <ul class="list-group list-group-flush border rounded list-box">
        <li
          v-for="(item, key) in internalDestination
            .map((item, inx) => ({ inx, ...item }))
            .filter((item) =>
              (displayFunc2
                ? displayFunc2(item)
                : item[label in item ? label : 'label']
              )
                .toLowerCase()
                .includes(searchDestination.toLowerCase())
            )"
          v-bind:key="key"
          :class="'list-item' + (item.selected ? ' active' : '')"
          @click="selectDestination(searchDestination ? item.inx : key)"
        >
          {{
            displayFunc2
              ? displayFunc2(item)
              : item[label in item ? label : "label"]
          }}
        </li>
        <li
          v-if="
            internalDestination.filter((item) =>
              (displayFunc2
                ? displayFunc2(item)
                : item[label in item ? label : 'label']
              )
                .toLowerCase()
                .includes(searchDestination.toLowerCase())
            ).length == 0 && internalDestination.length
          "
          class="list-item"
        >
          No results found
        </li>
      </ul>
    </div>
    <VMessages :value="errorBucket" color="error" />
  </div>
</template>

<script>
import VInput from "vuetify/lib/components/VInput/VInput.js";
import angleRight from "../assets/angle-right-solid.svg";
import angleLeft from "../assets/angle-left-solid.svg";
import angleDoubleLeft from "../assets/angle-double-left-solid.svg";
import angleDoubleRight from "../assets/angle-double-right-solid.svg";
import "../assets/style.css";
export default {
  extends: VInput,
  props: {
    source: Array,
    destination: Array,
    label: String,
    label2: String,
    editable: Boolean,
    disabled: Boolean,
    noRemove: Boolean,
    displayFunc1: { type: Function },
    displayFunc2: { type: Function },
  },
  data: function() {
    return {
      angleRight,
      angleLeft,
      angleDoubleLeft,
      angleDoubleRight,
      searchSource: "",
      searchDestination: "",
      internalSource: [],
      internalDestination: [],
    };
  },
  watch: {
    source: {
      handler(v) {
        // console.log(v);
        this.internalSource = v;
        this.$emit("input", this.internalDestination);
      },
      deep: true,
      immediate: true,
    },
    destination: {
      handler(v) {
        console.log(v);
        this.internalDestination = v;
        this.$emit("input", v);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    moveDestination: function() {
      let selected = this.internalSource.filter((f) => f.selected);
      if (!selected.length) return;
      this.$emit("add-destination", {
        selected,
      });
      selected = [];
      // let destination = [...selected, ...this.internalDestination];
      // let source = this.internalSource.filter(f => !f.selected);
      this.searchSource = "";
      this.searchDestination = "";
      // this.$emit("onChangeList", {
      //   source,
      //   destination
      // });
    },
    moveSource: function() {
      let selected = this.internalDestination.filter((f) => f.selected);
      if (!selected.length) return;
      this.$emit("add-source", {
        selected,
      });
      selected = [];
      // let source = [...selected, ...this.internalSource];
      // let destination = this.internalDestination.filter(f => !f.selected);
      this.searchSource = "";
      this.searchDestination = "";
      // this.$emit("onChangeList", {
      //   source,
      //   destination
      // });
    },
    selectDestination: function(key) {
      this.internalDestination = this.internalDestination.map((i, k) => {
        if (k === key) {
          i.selected = !i.selected;
        } else {
          i.selected = false;
        }
        return i;
      });
      let sList = this.internalDestination.filter((o) => o.selected === true);
      if (sList.length > 0) {
        // console.log(sList[0])
        this.$emit("selected", sList[0]);
      } else {
        // console.log("------------------------------------------------------------------")
        this.$emit("selected", null);
      }
    },
    selectSource: function(key) {
      this.internalSource = this.internalSource.map((i, k) => {
        if (k === key) {
          i.selected = !i.selected;
        } else {
          i.selected = false;
        }
        return i;
      });
    },
    updateDestination(v) {
      // console.log("update", v);
      this.internalDestination = v;
    },
  },
};
</script>
